import { defineRecipe } from '@chakra-ui/react';

/*
 * v3 note: `Divider` was renamed `Separator` and is a single flat element
 * (no slots), so this is a plain `defineRecipe`. The built-in `separator`
 * recipe already handles `orientation` (switches which border side reads
 * the thickness var) and a `size` scale for thickness. On top of that this
 * file restores two things v2's Divider had and v3's Separator dropped, plus
 * the app's one custom variant, `thick`:
 *
 * - `opacity: 0.6` (v2 theme baseStyle) — without it every separator reads
 *   ~40% darker.
 * - Orientation sizing (`height: 100%` vertical, `width: 100%` horizontal),
 *   which v2's Divider component set itself. Without it a vertical separator
 *   in a fixed-height flex row (page headers, CustomSteps) collapses to 0px.
 *
 * `thick` sets `--separator-thickness` directly rather than a literal
 * `borderWidth`, so it stays correct under both orientations (the
 * built-in's `orientation` variant reads that custom property for
 * whichever border side is active — border-top for horizontal,
 * border-inline-start for vertical). 2px matches v2's `borderWidth`.
 */

export const dividerTheme = defineRecipe({
  base: {
    opacity: 0.6,
  },
  variants: {
    variant: {
      thick: {
        '--separator-thickness': '2px',
        borderColor: 'tPurple.linkWater',
      },
    },
    orientation: {
      vertical: { height: '100%' },
      horizontal: { width: '100%' },
    },
  },
});

export default dividerTheme;
